import { ObjectMode } from '@databases/types';
import { Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getNewDatabase } from '@databases/utils/database/utils';

import { generateValuesForEntriesById } from '../utils';

import { databasesToContentId } from './constants';

export const getDatabaseWithFilters = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getNewDatabase();

  const fields = [
    ...Array.from({ length: 3 }, (_, index) => ({
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field ${index}`,
    })),
  ];

  const entriesById = generateValuesForEntriesById(baseDatabase.entries, fields);

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    contentId: databasesToContentId['databaseWithFilters'],
    entriesById,
    entries: Object.keys(entriesById),
    meta: {
      ...baseDatabase.meta,
      isLocked: false,
    },
    space: { key: 'TEST', name: 'Test', id: 1234 },
    operations: {
      delete: false,
      updateEntries: true,
      updateMetadata: true,
    },
    views: [
      {
        id: '0',
        name: 'All entries',
        settings: {
          layout: {
            coverFieldId: 'default',
            type: 'table',
            cardWidth: 'MEDIUM',
            showNumberedEntries: false,
          },
          calculations: {},
        },
      },
      {
        id: '1',
        name: 'View with filter',
        settings: {
          layout: {
            coverFieldId: 'default',
            type: 'table',
            cardWidth: 'MEDIUM',
            showNumberedEntries: false,
          },
          filter: {
            type: 'and',
            value: [
              {
                type: 'contains',
                fieldId: fields[0].id,
                not: true,
                value: 'text 3',
              },
            ],
          },
          calculations: {},
        },
      },
      {
        id: '2',
        name: 'View with sort',
        settings: {
          layout: {
            coverFieldId: 'default',
            type: 'table',
            cardWidth: 'MEDIUM',
            showNumberedEntries: false,
          },
          sort: {
            ascending: false,
            fieldId: fields[0].id,
          },
          calculations: {},
        },
      },
      {
        id: '3',
        name: 'View with hidden fields',
        settings: {
          fields: {
            [fields[0].id]: true,
            [fields[1].id]: false,
            [fields[2].id]: true,
          },
          layout: {
            coverFieldId: 'default',
            type: 'table',
            cardWidth: 'MEDIUM',
            showNumberedEntries: false,
          },
          calculations: {},
        },
      },
      {
        id: '4',
        name: 'View with equals filter',
        settings: {
          layout: {
            coverFieldId: 'default',
            type: 'table',
            cardWidth: 'MEDIUM',
            showNumberedEntries: false,
          },
          filter: {
            type: 'and',
            value: [
              {
                type: 'equals',
                fieldId: fields[0].id,
                value: {
                  type: 'text',
                  value: 'text 3',
                },
              },
            ],
          },
          calculations: {},
        },
      },
    ],
  } as Database<ObjectMode.EXISTING>;
};
